<ion-grid>
  <ion-row>
    <ion-col size="6" *ngFor="let item of bannerList">
      <ion-card class="border-r10 mar5" (click)="navigate(item)">
        <ion-img
          class="mem-icon"
          [src]="
            item?.image ||
            'https://i.picsum.photos/id/785/200/200.jpg?hmac=vvHnS4TgoGTRqwI2soaIhbOxE7Q-hhoZTTDe75h_fz4'
          "
        >
        </ion-img>
        <div class="text-overlay ion-text-center">
          <span *ngIf="item?.fees > 0" class="disco-chip"
            >{{ item?.fees }}%</span
          >
          <div class="mart10 font500">{{ item?.title }}</div>
        </div>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-grid>
